var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShowPagination
    ? _c("nav", [
        _c(
          "div",
          {
            staticClass: "pagination-container d-flex align-items-center",
            staticStyle: { float: "right" },
          },
          [
            _c("div", { staticClass: "rows-per-page-widget mr-4" }, [
              _c(
                "label",
                { staticClass: "me-2", attrs: { for: "rowsPerPage" } },
                [_vm._v("Rows per page:")]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.rowsPerPage,
                      expression: "rowsPerPage",
                    },
                  ],
                  staticClass: "form-select d-inline-block",
                  staticStyle: { width: "auto" },
                  attrs: { id: "rowsPerPage" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.rowsPerPage = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.rowsPerPageChanged,
                    ],
                  },
                },
                _vm._l(_vm.rowsPerPageOptions, function (option) {
                  return _c(
                    "option",
                    { key: option, domProps: { value: option } },
                    [_vm._v("\n          " + _vm._s(option) + "\n        ")]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "pagination justify-content-center" },
              [
                _c(
                  "li",
                  { class: { disabled: _vm.pagination.currentPage === 1 } },
                  [
                    _c(
                      "a",
                      {
                        class: { disabled: _vm.pagination.currentPage === 1 },
                        on: {
                          click: function ($event) {
                            return _vm.pageClicked(
                              _vm.pagination.currentPage - 1
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "left chevron icon" }, [
                          _vm._v("«"),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.hasFirst
                  ? _c(
                      "li",
                      {
                        staticClass: "page-item",
                        class: { active: _vm.isActive(1) },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.pageClicked(1)
                              },
                            },
                          },
                          [_vm._v("1")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasFirstEllipsis
                  ? _c("li", [
                      _c("span", { staticClass: "pagination-ellipsis" }, [
                        _vm._v("…"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.pages, function (page) {
                  return _c(
                    "li",
                    {
                      key: page,
                      staticClass: "page-item",
                      class: {
                        active: _vm.isActive(page),
                        disabled: page === "...",
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          on: {
                            click: function ($event) {
                              return _vm.pageClicked(page)
                            },
                          },
                        },
                        [_vm._v(_vm._s(page))]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.hasLastEllipsis
                  ? _c("li", [
                      _c("span", { staticClass: "pagination-ellipsis" }, [
                        _vm._v("…"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasLast
                  ? _c(
                      "li",
                      {
                        staticClass: "page-item",
                        class: {
                          active: _vm.isActive(this.pagination.totalPages),
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.pageClicked(
                                  _vm.pagination.totalPages
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.pagination.totalPages) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      class: {
                        disabled:
                          _vm.pagination.currentPage ===
                          _vm.pagination.totalPages,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.pageClicked(_vm.pagination.currentPage + 1)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "right chevron icon" }, [
                        _vm._v("»"),
                      ]),
                    ]
                  ),
                ]),
              ],
              2
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }